function LoopyPage() {
  return (
    <>
      <h1>Welcome to the loopy fan club!</h1>
      <p>Only Loopy Donut owners can see this page</p>
      <p>You can see this because you are a verified hodler. Nice work!</p>
      <p>Welcome to the club 😎</p>
    </>
  );
}

export default LoopyPage;
